import LightningIcon from "@uui/Lightning01";

import styled from "@mui/material/styles/styled";

import { Row, StackProps } from "@rui/Stack";

type RecommendationCountChipProps = StackProps & {
  color?: "primary" | "neutral";
};

const RecommendationCountChip = styled(
  ({ children, color: _, ...props }: RecommendationCountChipProps) => (
    <Row spacing={0.5} variant="center" {...props}>
      <LightningIcon />
      <span>{children}</span>
    </Row>
  )
)(({ color = "primary", theme }) => ({
  backgroundColor:
    color === "primary" ? theme.palette.shades.ghost[500] : "transparent",
  color:
    color === "primary"
      ? theme.palette.shades.primary[500]
      : theme.palette.shades.neutral[800],
  padding: theme.spacing(0.25, 1, 0.25, 0.5),
  borderRadius: "4px",
  fontWeight: 500,
  fontSize: "0.875rem",
  "& svg": {
    fontSize: "16px",
    color:
      color === "primary"
        ? theme.palette.shades.primary[500]
        : theme.palette.shades.neutral[300],
  },
}));

export default RecommendationCountChip;
